import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { BulkAddValidationDialogComponent } from '@components/bulk-add-validation-dialog/bulk-add-validation-dialog.component';
import { AppState } from '@services/appstate.service';
import { ImageGraphqlService } from "@services/image-graphql.service";
import { TagActions } from '@actions/tag.actions';
import { getTagSearchResults, getTagSearchQuery } from '../../reducers';


@Component({
    selector: 'app-bulk-tag-add',
    templateUrl: './bulk-tag-add.component.html',
    styleUrls: ['./bulk-tag-add.component.scss']
})
export class BulkTagAddComponent {
    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: any): void {
        if (this.showBulkTagResults != null && this.showBulkTagResults.nativeElement != null && !this.showBulkTagResults.nativeElement.contains(event.target)) {
            this.showResults = false;
        }
    }
    @ViewChild('showBulkTagResults') showBulkTagResults: ElementRef;

    tags$: Observable<any>;
    searchQuery$: Observable<string>;
    showResults: boolean = false;
    loading = false;

    constructor(
        private store: Store<AppState>,
        private tagActions: TagActions,
        private imageGraphqlService: ImageGraphqlService,
        private matDialogRef: MatDialogRef<any>,
        public dialog: MatDialog
    ) {
        this.tags$ = store.pipe(getTagSearchResults());
        this.searchQuery$ = store.pipe(getTagSearchQuery());
    }

    search(query: string) {
        this.showResults = true;
        if (query.length > 2) {
            this.store.dispatch(this.tagActions.searchTag(query));
        }
    }

    selectedTag(tag: any) {
        this.showResults = false;
        let images = this.matDialogRef.componentInstance.map((x: any) => x.id);
        let tags = { id: tag.id, className: tag.className, name: tag.id }
        let dialogRef: any = this.dialog.open(BulkAddValidationDialogComponent, {
            disableClose: false
        });
        dialogRef.componentInstance = {
            tags: tags
        };
        dialogRef.afterClosed().subscribe((result: any) => {
            this.loading = true;
            if (result === true) {
                this.imageGraphqlService.addMultipleImageTags(images, tags, 'add').pipe(take(1)).subscribe(() => {
                    this.loading = false;
                    this.matDialogRef.close(true);
                });
            } else {
                this.showResults = true;
                this.loading = false;
            }
        });
    }
}
